var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"cs-link",class:{ 'has-button': _vm.hasButton },attrs:{"href":_vm.href,"target":_vm.target},on:{"click":function($event){return _vm.clickHandler($event)}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.title))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }